import { paymentAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

/**
 * Returns the cached Payment Methods for the current country
 *
 * @example
 * const { data: paymentMethods } = await useMarketPaymentMethods()
 *
 */
export function useMarketPaymentMethods(options?: { immediate: boolean }) {
  const { market } = useMarketplace()

  return useHttpFetch(paymentAPI.getMethods, {
    queryParams: {
      country_code: market.countryCode,
    },
    transform: (data) => data.results,
    ...options,
  })
}
